import { dateShortFormat } from '@/filters/dateFormat'
import i18n from '@/i18n'
import { EPromotionStatus } from '@/services/connecteur'
import customerModule from '@/store/modules/CustomerModule'
import moment from 'moment'
import {
  extend, localize, ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import {
  between, max, max_value, min,
  min_value, required
} from 'vee-validate/dist/rules'
import Vue from 'vue'

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

localize('en')

// Pour des messages customs
// https://logaretm.github.io/vee-validate/guide/basics.html#messages
// The {_field_} field must be a positive number

extend('required', {
  ...required,
  message: i18n.t('rules.required').toString()
})

extend('max', {
  ...max,
  message: i18n.t('rules.max').toString()
})

extend('min', {
  ...min,
  message: i18n.t('rules.min').toString()
})

extend('max_value', {
  ...max_value,
  message: i18n.t('rules.max_value').toString()
})

extend('min_value', {
  ...min_value,
  message: i18n.t('rules.min_value').toString()
})

extend('between', {
  ...between,
  message: i18n.t('rules.between').toString()
})

extend('sell_in', {
  params: ['sellInStart', 'sellInEnd'],
  // @ts-ignore
  validate (value: string, { sellInStart, sellInEnd }) {
    return sellInStart !== 'undefined' && sellInEnd !== 'undefined'
  },
  message: i18n.t('rules.sell_in').toString()
})

extend('before_date', {
  params: ['target'],
  // @ts-ignore
  validate (value: string, { target }) {
    if (target && target !== 'undefined') {
      const targetDate = moment(target)
      const valueDate = moment(value)
      return valueDate.isSameOrBefore(targetDate)
    }
    return true
  },
  message: i18n.t('rules.before_date').toString()
})

extend('sell_out', {
  // Target is end of sell in Date
  params: ['target'],
  // @ts-ignore
  validate (value: string, { target }) {
    let isValid = true
    if (target && target !== 'undefined') {
      const sellInEndDate = moment(target)
      const sellOutStart = moment(value.split('~')[0].trim())
      isValid = sellOutStart.isSameOrAfter(sellInEndDate)
    }

    return isValid
  },
  message: i18n.t('rules.sell_out').toString()
})

extend('mla_required', {
  params: ['salesOrgId', 'status', 'customerId'],
  // @ts-ignore
  async validate (customerId: number, { salesOrgId, status }) {
    let isValid = true
    const currentCustomer = (
      await customerModule.getCustomers(salesOrgId)
    ).find(c => c.id === customerId)

    const isDraft = +status === EPromotionStatus.DRAFT
    const isChanged = +status === EPromotionStatus.CHANGED

    if (currentCustomer && (isDraft || isChanged)) {
      isValid = currentCustomer.mla !== undefined && currentCustomer.mla !== ''
    }

    return isValid
  },
  message: (fieldName, { salesOrgId, status, customerId }) => {
    const url = new URL(
      `customers?id=${customerId}&salesOrgId=${salesOrgId}`,
      `${process.env.VUE_APP_AAD_REDIRECT_URI}`
    )
    return i18n.t('rules.mla_required', { url: url.toString() }).toString()
  }
})

extend('after_today', {
  // @ts-ignore
  validate (value: string | date) {
    if (value && moment(value).isValid()) {
      return moment().startOf('day').isBefore(moment(value))
    }
    return true
  },
  message: i18n.t('rules.after_today').toString()
})

extend('date_between', {
  params: ['start', 'end'],

  // @ts-ignore
  validate (value: string | date, { start, end }) {
    const dateValue = moment(value)
    const dateStart = moment(start)
    const dateEnd = moment(end)

    if (dateValue.isValid() && dateStart.isValid() && dateEnd.isValid()) {
      return dateValue.isBetween(dateStart, dateEnd, undefined, '[]')
    }
    return true
  },
  message: (fieldName, params) => {
    return i18n
      .t('rules.date_between', {
        start: dateShortFormat(params.start),
        end: dateShortFormat(params.end)
      })
      .toString()
  }
})

extend('promotion_mechanism', {
  validate (value: { label: string, value: number } | string) {
    if (typeof value === 'string') {
      if (value.slice(-1) === '%' && (+(value.slice(0, -1)) < 100 && +(value.slice(0, -1)) > 0)) {
        return true
      }
      if (typeof +value === 'number' && !isNaN(+value)) {
        return true
      }
      return false
    }
    if (typeof value === 'object' && value.label ===
      i18n.t(`promotionMechanism.${value.value}`)
    ) {
      return true
    }
    return false
  },
  message: () => {
    return i18n
      .t('rules.promotion_mechanism').toString()
  }
})
